<div class="modal-header" data-bs-theme="ligth">
  <div *ngIf="isAdmin" class="mb-4">
  <h5 class="fw-bold mb-1">Liste des demandes en attente de validation</h5>
</div>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.close()"></button>
</div>
<div class="modal-body">
  <div class="row justify-content-center">
    <div class="col-12">
      <!-- Mode Admin : Liste des demandes en attente -->
      <div *ngIf="!loadingPending && pendingUsers.length > 0" class="table-responsive">
        <p class="text-muted mb-3">
          <strong>{{ pendingUsers.length }}</strong> demande(s) de partenariat en attente.
        </p>

        <table class="table table-hover align-middle">
          <thead class="table-light">
            <tr>
              <th>Profil</th>
              <th>Email</th>
              <th>Téléphone</th>
              <th>Date de naissance</th>
              <th>Adresse</th>
              <th class="text-center">Actions</th>
            </tr>
          </thead>

          <tbody>
            <tr *ngFor="let pendingUser of pendingUsers">
              <td class="d-flex align-items-center gap-2">
                <ngx-avatar [name]="(pendingUser.prenom || '') + ' ' + pendingUser.nom" size="40" [round]="true">
                </ngx-avatar>
                <div>
                  <strong>{{ pendingUser.prenom }} {{ pendingUser.nom }}</strong>
                </div>
              </td>

              <td>{{ pendingUser.email || 'N/A' }}</td>
              <td>{{ pendingUser.telephone || 'N/A' }}</td>
              <td>
                {{ pendingUser.date_naissance
                ? (pendingUser.date_naissance | date:'dd/MM/yyyy')
                : 'N/A' }}
              </td>
              <td>{{ pendingUser.adresse || 'N/A' }}</td>

              <td class="text-center">
                <button class="btn btn-success btn-sm me-2" (click)="validerDemande(pendingUser)" [disabled]="loading">
                  <i class="bi bi-check-circle"></i>
                </button>

                <button class="btn btn-outline-danger btn-sm" (click)="rejeterDemande(pendingUser)"
                  [disabled]="loading">
                  <i class="bi bi-x-circle"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
<!-- Aucun résultat -->
<div
  *ngIf="isAdmin && !loadingPending && pendingUsers.length === 0"
  class="d-flex flex-column align-items-center justify-content-center py-5 text-center"
>
  <i class="bi bi-inbox text-muted mb-3" style="font-size: 3rem;"></i>
  <h6 class="fw-bold mb-1">Aucune demande pour l’instant</h6>
  <p class="text-muted small">
    Les demandes de partenariat apparaîtront ici dès qu’un utilisateur en soumettra une.
  </p>
</div>

      <!-- Mode Client -->
      <div *ngIf="!isAdmin">
        <div class="card-body p-5 text-center">
          <div *ngIf="loadingUser" class="text-center py-5">
            <div class="spinner-border text-primary" role="status"></div>
          </div>

          <!-- Succès après soumission -->
          <div *ngIf="showSuccess && showWaiting" class="alert alert-success">
            <i class="bi bi-check-circle-fill me-2"></i>
            <strong>Votre demande a été soumise avec succès !</strong><br>
            Elle est maintenant en attente de validation par un administrateur.
            <hr>
            <button class="btn btn-primary" (click)="activeModal.close()">Retour à l'accueil</button>
          </div>

          <!-- En attente (avant refresh ou après annulation) -->
          <div *ngIf="showWaiting && !showSuccess" class="alert alert-info">
            <i class="bi bi-clock me-2"></i>
            <strong>Demande en attente</strong><br>
            Votre demande pour devenir partenaire est en cours de validation.<br>
            Vous serez notifié dès qu’elle sera traitée.
            <hr>
            <button class="btn btn-outline-danger" (click)="annulerDemande()" [disabled]="loading">
              <i class="bi bi-x-circle me-2"></i> Annuler la demande
            </button>
          </div>

          <!-- Bouton de demande -->
          <div *ngIf="showButton && !showWaiting && !showSuccess">
            <p class="lead mb-4">
              En tant que client, vous pouvez soumettre une demande pour devenir partenaire et proposer vos véhicules
              à
              la location.
            </p>

            <div class="alert alert-light border mb-5 text-start">
              <h6 class="mb-3"><i class="bi bi-person me-2"></i> Récapitulatif de votre profil</h6>
              <div class="row g-3 small">
                <div class="col-md-6"><strong>Nom complet :</strong> {{ user.prenom }} {{ user.nom }}</div>
                <div class="col-md-6"><strong>Email :</strong> {{ user.email || 'N/A' }}</div>
                <div class="col-md-6"><strong>Téléphone :</strong> {{ user.telephone }}</div>
                <div class="col-md-6"><strong>Année de naissance :</strong> {{ user.annee_naissance }}</div>
                <div class="col-md-6"><strong>Année début conduite :</strong> {{ user.annee_debut_conduite }}</div>
                <div class="col-md-6"><strong>Adresse :</strong> {{ user.adresse || 'N/A' }}</div>
              </div>
            </div>

            <button class="btn btn-success btn-lg px-5" (click)="demanderPartenaire()" [disabled]="loading">
              <i class="bi bi-star-fill me-2"></i>
              Soumettre
            </button>
            <button class="btn btn-outline-secondary btn-lg px-5 ms-3" (click)="activeModal.close()">
              Annuler
            </button>
          </div>

          <!-- Non éligible -->
          <div *ngIf="!showButton && !showWaiting && !showSuccess">
            <div class="alert alert-warning">
              <i class="bi bi-exclamation-triangle me-2"></i>
              Vous n'êtes pas éligible pour cette demande ou vous êtes déjà partenaire.
            </div>
            <button class="btn btn-primary" (click)="activeModal.close()">Retour</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
